import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';
import Login from './pages/Login';
import Signup from './pages/Signup';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import BranchManagerDashboard from './pages/BranchManagerDashboard';
import ContentDetail from './pages/ContentDetail';
import PublicContentDetail from './pages/PublicContentDetail';
import RegionalCoordinatorDashboard from './pages/RegionalCoordinatorDashboard';
import UserManagement from './pages/UserManagement';
import HeadOfficeAdminDashboard from './pages/HeadOfficeAdminDashboard';
import ContentEditorDashboard from './pages/ContentEditorDashboard';
import UploadContentPage from './pages/UploadContentPage';
import EditContentPage from './pages/EditContentPage';
import ContentDetailPage from './pages/ContentDetailPage';
import ContentDeletionPage from './pages/ContentDeletionPage';
import ContentApproverDashboard from './pages/ContentApproverDashboard';
import ReviewContentPage from './pages/ReviewContentPage';
import PrivateRoute from './components/PrivateRoute';
import UserDetails from './pages/UserDetails';
import AddUser from './pages/AddUser';
import BulkAddUsers from './pages/BulkAddUsers';
import RootRoute from './components/RootRoute';
import AuthenticatedRoute from './components/AuthenticatedRoute';
import AllLogsPage from './pages/AllLogsPage';
import UploadWordDocument from './pages/uploadWordDocument';

const AppContent = () => {

  return (
    <Routes>
      <Route path="/" element={<RootRoute />} />
      <Route element={<AuthenticatedRoute />}>
        <Route path="/login" element={<AuthLayout><Login /></AuthLayout>} />
      </Route>
      <Route path="/user/complete-profile/:token" element={<AuthLayout><Signup /></AuthLayout>} />
      <Route path="/password/reset/:token" element={<AuthLayout><ResetPassword /></AuthLayout>} />
      <Route path="/password/forgot" element={<AuthLayout><ForgotPassword /></AuthLayout>} />
      <Route path="/public/content/:id" element={<MainLayout><PublicContentDetail /></MainLayout>} />
      <Route element={<PrivateRoute allowedRoles={['Head Office Admin', 'Regional Manager', 'Content Editor', 'Content Reviewer', 'Trainer']} />}>
        <Route path="/users" element={<MainLayout><UserManagement /></MainLayout>} />
        <Route path="/logs" element={<MainLayout><AllLogsPage /></MainLayout>} />
        <Route path="/users/add-user" element={<MainLayout><AddUser /></MainLayout>} />
        <Route path="/users/bulk-add-users" element={<MainLayout><BulkAddUsers /></MainLayout>} />
        <Route path="/user/:id/details" element={<MainLayout><UserDetails /></MainLayout>} />
        <Route path="/admin/dashboard" element={<MainLayout><HeadOfficeAdminDashboard /></MainLayout>} />
        <Route path="/coordinator/dashboard" element={<MainLayout><RegionalCoordinatorDashboard /></MainLayout>} />
        <Route path="/editor/dashboard" element={<MainLayout><ContentEditorDashboard /></MainLayout>} />
        <Route path="/approver/dashboard" element={<MainLayout><ContentApproverDashboard /></MainLayout>} />
        <Route path="/branch/dashboard" element={<MainLayout><BranchManagerDashboard /></MainLayout>} />
        <Route path="/branch/content/:id" element={<MainLayout><ContentDetail /></MainLayout>} />
        <Route path="/content/:id" element={<MainLayout><ContentDetailPage /></MainLayout>} />
        <Route path="/content/:contentId/deletion-request/:deletionRequestId" element={<MainLayout><ContentDeletionPage /></MainLayout>} />
        <Route path="/content/upload" element={<MainLayout><UploadContentPage /></MainLayout>} />
        <Route path="/word/upload" element={<MainLayout><UploadWordDocument /></MainLayout>} />
        <Route path="/content/:id/edit" element={<MainLayout><EditContentPage /></MainLayout>} />
        <Route path="/content/:id/review" element={<MainLayout><ReviewContentPage /></MainLayout>} />
      </Route>
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;